export default __webpack_public_path__ + "static/media/OnRollLogo.0401690f.svg";